

import { defineComponent, ref } from 'vue';
import { useRoute } from 'vue-router';

import 'animate.css';

import pokeApi from '@/api/pokeApi';

import NavbarComponent from '@/components/NavbarComponent.vue';
import PokemonInfo from '@/components/PokemonInfo.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import SpinnerComponent from '@/components/SpinnerComponent.vue';

export default defineComponent({
  name: 'PokemonInfoView',
  components: {
    NavbarComponent,
    PokemonInfo,
    FooterComponent,
    SpinnerComponent
  },
  setup() {
    
    const router = useRoute();

    const pokemon = ref({});

    const loadPokemon = async() => {
      const { data } = await pokeApi.get( router.params['id'] as string );
      pokemon.value = data;
    }

    loadPokemon();

    return {
      pokemon
    }

  }
});
